export const geoApiOptions = {
	method: 'GET',
	headers: {
		'X-RapidAPI-Key': '48ea1c8580mshbbc34c77359f8acp10b37ejsnc1cb7ccbd59b',
		'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
	}
};

export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo"
export const WEATHER_API_URL = "api.openweathermap.org/data/2.5";
export const WEATHER_API_KEY = "13fb992eae2c48136e5cf0c677815701";

